<cm-add-item-dialog title="Add new user" [confirmDisabled]="!$isFormValid()" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <div cm-dialog-content class="cm-form-fields">
        <div class="cm-field-group">
            <cm-input-container>
                <ng-container cm-inline-label>Email:</ng-container>
                <ng-container cm-input>
                    <cm-string-input [value]="$userData().email" (valueChange)="onEmailChange($event)"></cm-string-input>
                </ng-container>
            </cm-input-container>
            @if ($errors()["email"]) {
                <div class="cm-field-error">{{ $errors()["email"] }}</div>
            }
        </div>
        @if ($canAddUserToAnyOrganization()) {
            <cm-organization-select
                [updateOrganization]="updateOrganization.bind(this)"
                [organizationId]="$organizationId() ?? null"
                [showIfViewedByOwner]="false"
                [showLabel]="false"
                [usedInAddEntityContext]="true"
            ></cm-organization-select>
        }
        <div class="cm-field-group">
            <mat-form-field appearance="outline">
                <mat-select
                    [value]="$userData().role"
                    (valueChange)="onRoleChange($event)"
                    placeholder="Select role"
                    [class.cm-input-error]="$errors()['role']"
                >
                    @for (role of $membershipRoles(); track role) {
                        <mat-option [value]="role">{{ role }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if ($errors()["role"]) {
                <div class="cm-field-error">{{ $errors()["role"] }}</div>
            }
        </div>
    </div>
</cm-add-item-dialog>
